<template>
    <div>
        <!-- <div class="tabsFather">
            <div v-for="(item,index) in tabsData" :class="[tabsIndex == item.type ? 'tabsActive' : '','tabsClass']"  @click="tabsClick(item)">{{ item.title }}</div>
        </div> -->
        <div class="line999"></div>
        <template v-if="tabsIndex == '10'">
            <div class="commonFather">
                <div class="commonList" v-for="(item,index) in tabsData" :key="index"  @click="tabsClick(index)">
                    <div class="commonListLeft">{{ item.title }}</div>
                    <div class="commonListRight">{{ item.date }}</div>
                </div>
            </div>
        
            <div class="line999"></div>
            <div class="mob-line"></div>
            <!-- <van-pagination v-model="currentPage" :total-items="1" :items-per-page="5" /> -->
            
        </template>
       
        <template>
            <!-- <div class="tabs1Title">大事记</div> -->
            <div class="tabs1">
                <div class="Articlebox">
                    <h1>{{details.title}}</h1>
                    <div class="a-text-c">
                        <div v-html="details.text"> 
                            
                        </div> 
                    </div>
                </div>
                
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "mobIntroduce",
        data(){
            return{
                tabsData:[
                    {title:"公司新闻",index:'3-1',date:"2016-07-14",type:'2'},
                    {title:"媒体新闻",index:'3-2',date:"2017-01-01",type:'1'},
                ],
                currentPage:"1",
                tabsIndex:"3",
                details:{
                    title:"百台传祺GE3交付小易出行 打造高品质共享汽车",text:""
                },
                detailsData:[
                    {id:"1",title:"充电桩生产及销售业务",text:'<p><span style="color: rgb(51, 51, 51); font-family: Arial; background-color: rgb(255, 255, 255);">Tellus Power集团拥有独立的充电桩研发、生产能力，充电桩产品水平世界领先。自主研发的充电桩产品具有智能性强，安全性高等特点，通过最严苛的美国UL、欧盟CE、中国国标等认证，兼容性符合国际，欧美SAE Combo等快速充电标准，能够与国内外所有主流新能源汽车完成充电协议对标。</span><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><span style="color: rgb(51, 51, 51); font-family: Arial; background-color: rgb(255, 255, 255);">产品展示</span><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585989962.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 100%;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585890982.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 100%;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585631266.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 100%;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585610016.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width: 100%;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585270289.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width:100%;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="../../static/images/1682490585260476.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); width:100%;"><br style="color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/09ed4455-3625-4b79-90c7-487b80191699.png" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; white-space: normal; background-color: rgb(255, 255, 255); height: 397px; width: 100%;"></p> '},
                    {id:"2",title:"充电站建设及运营业务",text:'<p><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; background-color: rgb(255, 255, 255);">配电及充电系统：充电站核心内容，配电系统（配电室、分配电箱、线缆等）及充电设备的安装与施工<br>监控安防系统：为满足充电站区域的安全目标，根据实际现场情况设置机位实际定点<br>站点导视\视觉系统：针对充电站所在停车场区域的导示导引系统，以及广告、服务相关的信息展示系统<br>充电站运营系统：基于充电站整体运营的支持系统，包括内部运营平台、结算系统、实际运营所需的相关物资、人力与技术支持。</span><br style="color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);"><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/275357f8-555c-4db9-bec0-53061f21dcc0.png" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); width: 100%; height: 354px;"></p> '},
                    {id:"3",title:"传统光伏业务",text:'<p style="line-height: 16px;"><a style="font-size:12px; color:#0066cc;" href="/uploads/common/1611826040769928.png" title="APP下载二维码.png"></a></p><p style="line-height: 16px;"><span style="background-color: rgb(255, 255, 255); color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px;">传统能源、燃料成本将会呈持续增长的趋势，光伏发电可以明显的提高效率和降低成本。</span><br></p><p><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px; background-color: rgb(255, 255, 255);">光伏系统的主要功能：</span><br style="color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255);"></p><p><span style="margin: 0px; padding: 0px; border: 0px;">•减少火电用量，分担用电负荷；优化能源利用，削峰填谷。</span></p> <p><span style="margin: 0px; padding: 0px; border: 0px;">•遮阳隔热，降低空调费用；隔音、不透水、可对抗恶劣天气；可加入智能电网，实现能源互联。</span></p> <p><span style="margin: 0px; padding: 0px; border: 0px;">•光伏发电＋充电站＝100%清洁能源</span><br>&nbsp;</p><p><img alt="" src="https://tellusimg.telluspowersales.com/tpgc/test/9833a477-6faa-4ca5-9256-eb3d3c551376.jpg" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle; color: rgb(51, 51, 51); font-family: 微软雅黑; font-size: 14px; white-space: normal; background-color: rgb(255, 255, 255); width: 100%; height: 285px;"></p><p><br></p>'},
                    {id:"4",title:"BIPV(光伏)业务",text:'<p class="ordinary-output target-output clearfix" style="margin-top: 0px; margin-bottom: 0px; padding: 0px; border: 0px;"><span style="margin: 0px; padding: 0px; border: 0px;">Tellus Power旗下的德国Asola是全球仅有的3家有能力生产太阳能屋顶系统的公司之一，旗下Asola VITRUM系列产品是不同于传统光伏的新型材料。Asola VITRUM作为BIPV是对传统光伏的升级，形成了一种性能优良的建筑材料。</span></p><p class="ordinary-output target-output clearfix" style="margin-top: 0px; margin-bottom: 0px; padding: 0px; border: 0px; text-align: center;"><br>&nbsp;</p><p class="ordinary-output target-output clearfix" style="margin-top: 0px; margin-bottom: 0px; padding: 0px; border: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br><span style="margin: 0px; padding: 0px; border: 0px;">BIPV本身具有隔音、隔热、防爆、防风、防水、防潮、防恶劣天气等特质，作为建筑材料，其牢固程度经得起考验，作为幕墙或天台顶棚都完全达标。同时，作为升级版，BIPV也具备传统光伏的光电转化功能，最高转化率可达22%，白天充分吸收太阳能并进行储存，以起到辅助能源供应之用。</span><br>&nbsp;</p><p></p><p><br></p>'},
                    {id:"5",title:"分时租赁业务",text:'<p><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; background-color: rgb(255, 255, 255);">电动汽车分时租赁是新能源汽车生态网络的商业延伸。相比传统汽车租赁的商业模式，电动汽车分时租赁不但降低了出行成本，同时也提升了消费者乃至全社会的节能环保意识，推动了新能源产业链的发展。</span><span style="margin: 0px; padding: 0px; border: 0px; color: rgb(51, 51, 51); font-family: Arial; font-size: 14px; background-color: rgb(255, 255, 255);">Tellus Power集团旗下分时租赁品牌“小易租车”基于Tellus Power集团在充电运营领域、网络资源、以及品牌方面的优势，打造了独有的“车+桩+充电+停车”运营模式，为用户带去了极佳的体验。<br><img alt="" src="http://picture.telluspowergreen.cn/uploads/common/20201217/1608186535134552.png" style="margin: 0px; padding: 0px; border: 0px; vertical-align: middle;width:100%"><br>2016年年底，Tellus Power集团与顺义区签订了战略合作框架协议，将联合政府打造北京乃至全国电动汽车分时租赁示范基地。未来2-3年，预计在顺义区陆续投入超过1000辆新能源汽车。打造满足居民出行、公务出行、商务出行等多元化绿色出行整体解决方案，为顺义区乃至首都产业转型升级提供了强大助推力。</span></p> '},
                    {id:"6",title:"充电运营平台小程序解决方案",text:'<p><span style="color: rgb(71, 82, 93); font-family: Helvetica, Arial, &quot;Hiragino Sans GB&quot;, &quot;Source Han Sans CN&quot;, Roboto, &quot;Microsoft Yahei&quot;, sans-serif; font-size: 14px; background-color: rgb(255, 255, 255);">《小易出行》是一款电动汽车充电小程序，让用户可以快速找到附近充电桩，支持导航，帮助用户快速找到充电站，为爱车充电。</span></p>'},
                ],
            }
        },
        methods:{
            tabsClick(e){
                console.log(e)
                this.tabsIndex = e.type
                console.log( this.tabsIndex)
                this.$router.push({path: "mobNews",query:{type:e.type}}); 

            },
            goDetails(e){
                console.log(e)
                this.tabsIndex = e.type
                this.$router.push({path: "mobNewsDetails",query:{data:e}});  
            },
        },
        created(e){
            console.log(this.$route.query)
            let data = this.$route.query.data
            this.listDataNew = this.listData
            this.tabsIndex = data.type
            this.detailsData.map((item,index)=>{
                if(item.id == data.id){
                    this.details = item
                }
            })
        }
    }
</script>

<style scoped>
.a-text-c{
    font-size: 0.38rem;
    color: #000;
    padding: 5px 0.4rem;
}
.Articlebox h1 {
    display: block;
    padding: 0px 0 5px 5px;
    text-align: center;
    font-size: 0.43rem;
    font-weight: 600;
}
.pageClass{
    width: 100%;
    text-align: center;
}
.commonListRight{
    color: #999;
    font-size: 0.34rem;
}
.commonListLeft{
    font-size: 0.38rem;
    color: #000;
    width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.commonList{
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
}
.commonFather{
    background-color: #fff;
}
.detailClass{
    margin-top: 0px; 
    margin-bottom: 0px; 
    padding: 15px 0px 15px 65px; 
    border-width: 0px 0px 1px; 
    border-top-style: initial; 
    border-right-style: initial; 
    border-bottom-style: solid; 
    border-left-style: initial; 
    border-top-color: initial; 
    border-right-color: initial; 
    border-bottom-color: rgb(221, 221, 221); 
    border-left-color: initial; 
    border-image: initial; 
    font-size: 15px; 
    line-height: 28px;
}
.monClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    width: 52px; 
    height: 28px; 
    display: block; 
    background-color: rgb(185, 185, 185); 
    text-align: center; 
    color: rgb(255, 255, 255); 
    font-size: 18px;
}
.ulClass{
    margin: 0px; 
    padding: 0px; 
    border: 0px; 
    /* width: 80%;  */
    /* float: right;  */
    position: relative;
}
.h2Class{
    /* margin: 0px 0px 0px; */
    margin-right: 50px;
    padding: 0px; 
    font-size: 18px !important; 
    width: 80px; 
    /* float: left;  */
    color: rgb(137, 137, 137); 
    line-height: 28px;
}
.tabs1Title{
    text-align: center;
    font-size: 0.45rem;
    font-weight: 600;
    padding-top: 0.4rem;
}
.tabs1{
    font-size: 0.35rem;
    padding: 0.2rem 0.01rem;
    /* line-height: 2rem; */
}
.tabsActive{
    color: #18D1BB !important;
}
.pageClass{
    width: 100%;
    text-align: center;
}
.mob-line{
    width: 100%;
    height: 0.08rem;
    background-color: #18D1BB;
    /* margin: 0.2rem 0; */
}
.commonListRight{
    color: #999;
    font-size: 0.34rem;
}
.commonListLeft{
    font-size: 0.38rem;
    color: #000;
}
.commonList{
    padding: 0.2rem;
    display: flex;
    justify-content: space-between;
}
.line999{
    width: 100%;
    height: 6px;
    background-color: #eee;
}
.commonFather{
    background-color: #fff;
}
.tabsClass{
   
    color: #333;
    font-size: 0.38rem;
    margin-right: 15px;
}
.tabsFather{
    display: flex;
    align-items: center;
    padding-left: 15px;
    height: 44px;
    line-height: 44px;
}
</style>